import Head from "next/head";
import Layout from "../partial/Layout";
import Container from "../components/Container";
import { Col } from "../components/Col";
import Button from "../components/Button";

const Error = () => {
  return (
    <>
      <Head>
        <title>404 Not Found</title>
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Layout step={1} urlCode="">
        <Container>
          <Col>
            <div style={{ minHeight: "70vh" }}>
              <h1>404 Not Found</h1>

              <p className="marginb25" style={{ maxWidth: "900px" }}>
                Oh no! It looks like the link is broken or the page has been moved. If the issue continues, call us on
                (02) 9298 3777.
              </p>

              <Button
                btnHref="https://www.sea.museum"
                linkType="exlink"
                btnClass="yellow,large"
                ariaLabel="Go back to home page"
              >
                HOME
              </Button>
            </div>
          </Col>
        </Container>
      </Layout>
    </>
  );
};

export default Error;
